import { render, staticRenderFns } from "./vSelectBrand.vue?vue&type=template&id=6014bca6&scoped=true&"
import script from "./vSelectBrand.vue?vue&type=script&lang=js&"
export * from "./vSelectBrand.vue?vue&type=script&lang=js&"
import style0 from "./vSelectBrand.vue?vue&type=style&index=0&id=6014bca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6014bca6",
  null
  
)

export default component.exports